import * as React from "react";
import { styled } from "@mui/material";
import { SettingsTextInput, SettingsTextInputProps } from "./settingsTextInput";
import { useEffect, useState } from "react";

//region [[ Styles ]]

const SettingsNumericInputView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SettingsNumericInputProps {
  onChange: (newValue: any) => void;
  value: string;
  floatingPoint?: boolean;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const FLOAT_REGEX = "[+-]?([0-9]*[.])?[0-9]*";
const INT_REGEX = "[+-]?[0-9]*";
export const SettingsNumericInput = ({
  value,
  floatingPoint,
  ...props
}: SettingsNumericInputProps) => {
  const [stringValue, setStringValue] = useState(value);

  useEffect(() => {
    if (
      floatingPoint &&
      parseFloat(value) !== parseFloat(stringValue) &&
      !isNaN(parseFloat(value))
    ) {
      setStringValue(value);
      return;
    }
    if (
      parseInt(value) !== parseInt(stringValue) &&
      !isNaN(parseFloat(value))
    ) {
      setStringValue(value);
    }
  }, [value, floatingPoint, setStringValue, stringValue]);

  const handleValueChange = (e) => {
    const stringValue = e.target.value;
    try {
      if (floatingPoint) {
        const floatingPointValue = parseFloat(stringValue);
        // Make sure only valid values are entered
        setStringValue(
          stringValue.match(FLOAT_REGEX)?.[0] ||
            (isNaN(floatingPointValue) ? "" : floatingPointValue),
        );
        return props.onChange(floatingPointValue);
      }
      const integerValue = parseInt(stringValue);
      setStringValue(
        stringValue.match(INT_REGEX)?.[0] ||
          (isNaN(integerValue) ? "" : integerValue),
      );
      props.onChange(integerValue);
    } catch (e) {}
  };

  return (
    <SettingsTextInput
      value={stringValue}
      onChange={handleValueChange}
      disabled={props.disabled}
    />
  );
};
